<script setup lang="ts">

interface IProps {
  icon: string
  size?: 'xs' | 'sm' | 'lg'
  color?: string
  active?: boolean
}

const props = withDefaults(defineProps<IProps>(), {
  size: 'sm',
})

const ButtonSizeMap = {
  xs: 'h-5 w-5',
  sm: 'h-6 w-6',
  lg: 'h-8 w-8'
}

const buttonSize = computed(() => {
  return ButtonSizeMap[props.size]
})

const defaultColor = computed(() => {
  if (props.color) {
    return `text-${props.color} hover:text-${props.color}`
  }
  return 'text-primary/40 hover:text-primary'
})
</script>

<template>
  <button
    class="icon-button"
    :class="[buttonSize, defaultColor, active]"
  >
    <FontAwesomeIcon
      class="text-inherit"
      :icon="icon"
      :size="size"
    />
  </button>
</template>

<style scoped lang="scss">
.icon-button {
  @apply flex-shrink-0 inline-flex items-center justify-center transition-all duration-300 ease-[ease] rounded;

  &:hover {
    @apply bg-primary/5;
  }

  &:focus, &:active {
    @apply outline-none bg-primary/10;
  }
}
</style>